import { Component, OnInit, Input, forwardRef, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { FormDataService } from '../../../../services/v6/FormController/form-data.service';
import { NbToastrService, NbTooltipModule, NbSpinnerModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { StorageService } from '../../../shared/services/storage.service';
import { NgSelectModule } from '@ng-select/ng-select';

// Reexportar labels de Fase do negócio para uso em outros componentes (ex.: modal detalhe cliente)
export { FASE_NEGOCIO_LABELS, getFaseNegocioLabel } from '../../../shared/constants/fase-negocio-labels';

export enum DefinicoesFormulario {
  SITUACAO_CPF_CNPJ = '10000000-0000-0000-0000-000000000001',
  SITUACAO_NEGOCIO = '10000000-0000-0000-0000-000000000002',
  CADASTRO = '10000000-0000-0000-0000-000000000003',
  PROBABILIDADE = '10000000-0000-0000-0000-000000000004',
  TRABALHO_COMPLETO = '10000000-0000-0000-0000-000000000005',
  ANDAMENTO_PROCESSO = '10000000-0000-0000-0000-000000000006',
  CLASSIFICACAO = '10000000-0000-0000-0000-000000000007',
  TIPO_COMISSOES = '10000000-0000-0000-0000-000000000008',
  TIPO_COMISSOES_RECEB = '10000000-0000-0000-0000-000000000009',
  TIPO_GASTO = '10000000-0000-0000-0000-000000000010',
  INVENTARIO = '10000000-0000-0000-0000-000000000011',
  CONHECIMENTO_ATIVOS = '10000000-0000-0000-0000-000000000012',
  STATUS_TRANSFERENCIA = '10000000-0000-0000-0000-000000000013',
  FASE_NEGOCIO = '10000000-0000-0000-0000-000000000014',
  CICLO = '10000000-0000-0000-0000-000000000015'
}

export const NomesDefinicoesFormulario = {
  [DefinicoesFormulario.SITUACAO_CPF_CNPJ]: 'Situação do CPF/CNPJ',
  [DefinicoesFormulario.SITUACAO_NEGOCIO]: 'Situação do Negócio',
  [DefinicoesFormulario.CADASTRO]: 'Cadastro',
  [DefinicoesFormulario.PROBABILIDADE]: 'Probabilidade',
  [DefinicoesFormulario.TRABALHO_COMPLETO]: 'Trabalho Completo',
  [DefinicoesFormulario.ANDAMENTO_PROCESSO]: 'Andamento do Processo',
  [DefinicoesFormulario.CLASSIFICACAO]: 'Classificação',
  [DefinicoesFormulario.TIPO_COMISSOES]: 'Tipo de Comissões',
  [DefinicoesFormulario.TIPO_COMISSOES_RECEB]: 'Tipo Comissões Receb.',
  [DefinicoesFormulario.TIPO_GASTO]: 'Tipo de Gasto',
  [DefinicoesFormulario.INVENTARIO]: 'Inventário',
  [DefinicoesFormulario.CONHECIMENTO_ATIVOS]: 'Conhecimento Ativos',
  [DefinicoesFormulario.STATUS_TRANSFERENCIA]: 'Status Transferência',
  [DefinicoesFormulario.FASE_NEGOCIO]: 'Fase do Negócio',
  [DefinicoesFormulario.CICLO]: 'Ciclo Status Negócio'
};
export const DataTypesDefinicoesFormulario = {
  [DefinicoesFormulario.SITUACAO_CPF_CNPJ]: 'string',
  [DefinicoesFormulario.SITUACAO_NEGOCIO]: 'string',
  [DefinicoesFormulario.CADASTRO]: 'string',
  [DefinicoesFormulario.PROBABILIDADE]: 'string',
  [DefinicoesFormulario.TRABALHO_COMPLETO]: 'string',
  [DefinicoesFormulario.ANDAMENTO_PROCESSO]: 'string',
  [DefinicoesFormulario.CLASSIFICACAO]: 'number',
  [DefinicoesFormulario.TIPO_COMISSOES]: 'string',
  [DefinicoesFormulario.TIPO_COMISSOES_RECEB]: 'string',
  [DefinicoesFormulario.TIPO_GASTO]: 'string',
  [DefinicoesFormulario.INVENTARIO]: 'string',
  [DefinicoesFormulario.CONHECIMENTO_ATIVOS]: 'number',
  [DefinicoesFormulario.STATUS_TRANSFERENCIA]: 'string',
  [DefinicoesFormulario.FASE_NEGOCIO]: 'string',
  [DefinicoesFormulario.CICLO]: 'string'
};

interface RespostaOpcaoFormulario {
  ordem: number;
  codigo: number;
  textoMostrado: string;
}

@Component({
  selector: 'ngx-dynamic-select',
  templateUrl: './form-generico.component.html',
  styleUrls: ['./form-generico.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DynamicSelectComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [NgSelectModule, FormsModule, CommonModule, NbTooltipModule, NbSpinnerModule]
})
export class DynamicSelectComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() formId: string;
  @Input() placeholder: string = 'Selecione';
  @Input() tamanho: string = 'small';
  @Input() formato: string = 'semi-round';
  @Input() status: string = 'primary';
  @Input() desabilitado: boolean = false;
  @Input() rotulo: string = '';
  @Input() larguraCompleta: boolean = true;
  @Input() multiple: boolean = false;
  @Input() forcarRecarregamento: boolean = false;
  /** Quando definido (ex.: `'body'`), o painel do ng-select é renderizado fora do card/modal e não é cortado pelo overflow. */
  @Input() appendTo?: string;
  @Output() mudancaValorSelecionado = new EventEmitter<number | null>();

  public DefinicoesFormulario = DefinicoesFormulario;
  public NomesDefinicoesFormulario = NomesDefinicoesFormulario;

  opcoesFormulario: RespostaOpcaoFormulario[] = [];
  carregando: boolean = true;

  private aoMudar: any = () => { };
  private aoTocar: any = () => { };

  private _valorSelecionadoInterno: number | number[] | null = null;
  private _valorSelecionadoExterno: string | string[] | number | number[] | null = null;
  private _valorNaoReconhecido: boolean = false;
  private _valoresNaoReconhecidos: number[] = [];

  get valorSelecionadoInterno(): number | number[] | null {
    return this._valorSelecionadoInterno;
  }

  set valorSelecionadoInterno(valor: number | number[] | null) {
    if (this.carregando) {
      this._valorSelecionadoInterno = valor;
    } else if (this.multiple) {
      const valores = valor as number[];
      if (valores) {
        this._valoresNaoReconhecidos = valores.filter(v => !this.valorExisteNasOpcoes(v));
        this._valorNaoReconhecido = this._valoresNaoReconhecidos.length > 0;
        this._valorSelecionadoInterno = valores.filter(v => this.valorExisteNasOpcoes(v));
      } else {
        this._valorSelecionadoInterno = [];
        this._valoresNaoReconhecidos = [];
        this._valorNaoReconhecido = false;
      }
    } else {
      const valorNumerico = valor as number;
      this._valorNaoReconhecido = valorNumerico !== null && !this.valorExisteNasOpcoes(valorNumerico);
      this._valorSelecionadoInterno = this._valorNaoReconhecido ? null : valorNumerico;
    }
    const valorExterno = this.converterParaValorExterno(this._valorSelecionadoInterno);
    this._valorSelecionadoExterno = valorExterno;

    this.aoMudar(valorExterno);
    this.aoTocar();
    this.mudancaValorSelecionado.emit(this._valorSelecionadoExterno as number);
  }

  get valorNaoReconhecido(): boolean {
    return this._valorNaoReconhecido;
  }

  get mensagemValorNaoReconhecido(): string {
    if (this.multiple && this._valoresNaoReconhecidos.length > 0) {
      return 'Um ou mais valores estão fora do padrão';
    }
    return 'Valor fora do padrão';
  }

  private valorExisteNasOpcoes(valor: number): boolean {
    return this.opcoesFormulario.some(opcao => opcao.codigo === valor);
  }

  private converterParaValorExterno(valorInterno: number | number[] | null): string | string[] | number | number[] | null {
    if (valorInterno === null) {
      return null;
    }

    const dataType = DataTypesDefinicoesFormulario[this.formId as keyof typeof DataTypesDefinicoesFormulario];

    if (this.multiple) {
      if (dataType === 'string') {
        if (Array.isArray(valorInterno)) {
          return valorInterno.map(v => v.toString());
        } else {
          return [valorInterno.toString()];
        }
      }
      return valorInterno;
    } else {
      if (dataType === 'string') {
        return valorInterno.toString();
      }
      return valorInterno;
    }
  }

  private gerarChaveCache(): string {
    return `form_opcoes_${this.formId}`;
  }

  public limparCache(): void {
    const cacheKey = this.gerarChaveCache();
    this.storageService.removeLocalItem(cacheKey);
  }

  public static limparTodosCachesFormularios(storageService: StorageService): void {
    Object.values(DefinicoesFormulario).forEach(formId => {
      const baseKey = `form_opcoes_${formId}`;
      storageService.removeLocalItem(baseKey);
    });
  }

  public static async precarregarTodosFormularios(
    formDataService: FormDataService,
    storageService: StorageService
  ): Promise<boolean> {

    try {
      const formIds = Object.values(DefinicoesFormulario);
      const promises = formIds.map(async (formId) => {
        const cacheKey = `form_opcoes_${formId}`;

        try {
          const resposta = await formDataService.GetOpcoesForm(formId).toPromise();
          if (resposta.success) {
            const opcoes = resposta.data.sort((a, b) => a.ordem - b.ordem);
            storageService.setLocalItem(cacheKey, JSON.stringify(opcoes));
            return true;
          } else {
            return false;
          }
        } catch (error) {
          return false;
        }
      });

      const resultados = await Promise.all(promises);
      const sucessos = resultados.filter(r => r).length;
      const total = formIds.length;

      if (sucessos === total) {
        const agora = new Date().toISOString();
        storageService.setLocalItem('form_preload_last_complete', agora);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  public static verificarSeDevePrecarregar(storageService: StorageService): boolean {
    const ultimoPrecarregamento = storageService.getLocalItem('form_preload_last_complete');
    if (!ultimoPrecarregamento) {
      return true;
    }
    try {
      const dataUltimoPrecarregamento = new Date(ultimoPrecarregamento);
      const hoje = new Date();
      const ehNovodia = dataUltimoPrecarregamento.toDateString() !== hoje.toDateString();

      if (ehNovodia) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return true;
    }
  }

  constructor(
    private formDataService: FormDataService,
    private toastrService: NbToastrService,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.carregarOpcoesFormulario();
  }

  ngOnChanges(mudancas: SimpleChanges): void {
    if (mudancas['formId'] && !mudancas['formId'].firstChange) {
      this.carregarOpcoesFormulario();
    }
    if (mudancas['forcarRecarregamento'] && mudancas['forcarRecarregamento'].currentValue === true) {
      this.limparCache();
      this.carregarOpcoesFormulario();
    }
  }


  carregarOpcoesFormulario(): void {
    if (!this.formId) {
      return;
    }

    const cacheKey = this.gerarChaveCache();
    const dadosCache = !this.forcarRecarregamento ? this.storageService.getLocalItem(cacheKey) : null;

    if (dadosCache) {
      try {
        const opcoesCacheadas: RespostaOpcaoFormulario[] = JSON.parse(dadosCache);
        this.opcoesFormulario = opcoesCacheadas;
        this.opcoesFormulario.sort((a, b) => a.ordem - b.ordem);
        this.carregando = false;
        return;
      } catch (error) {
        this.storageService.removeLocalItem(cacheKey);
      }
    }

    this.formDataService.GetOpcoesForm(this.formId).subscribe({
      next: (resposta) => {
        this.carregando = false;
        if (resposta.success) {
          this.opcoesFormulario = resposta.data;
          this.opcoesFormulario.sort((a, b) => a.ordem - b.ordem);
          this.storageService.setLocalItem(cacheKey, JSON.stringify(this.opcoesFormulario));
        } else {
          this.opcoesFormulario = [];
        }

        setTimeout(() => {
          this.valorSelecionadoInterno = this.valorSelecionadoInterno;
        }, 0);
      },
      error: (erro) => {
        this.opcoesFormulario = [];
        this.toastrService.danger(
          erro.error?.message || 'Erro ao carregar opções',
          'Erro'
        );
        this.carregando = false;
      }
    });
  }

  writeValue(valor: string | string[] | number | number[] | null): void {
    let isArray = Array.isArray(valor);
    let isNumber = typeof valor === 'number' || (isArray && valor.length > 0 && typeof valor[0] === 'number');

    this._valorSelecionadoExterno = valor;
    if (Array.isArray(valor)) {
      const valoresNumericos = valor.map(v => Number(v)).filter(v => !isNaN(v)) as number[];
      this.valorSelecionadoInterno = valoresNumericos.length > 0 ? valoresNumericos : null;
    } else if (!isNumber) {
      if (valor === null) {
        this.valorSelecionadoInterno = null;
      } else {
        const valorNumerico = Number(valor);
        this.valorSelecionadoInterno = isNaN(valorNumerico) ? null : valorNumerico;
      }
    } else if (typeof valor === 'number') {
      this.valorSelecionadoInterno = valor;
    } else {
      this.valorSelecionadoInterno = null;
    }
  }

  registerOnChange(fn: any): void {
    this.aoMudar = fn;
  }

  registerOnTouched(fn: any): void {
    this.aoTocar = fn;
  }

  setDisabledState(estaDesabilitado: boolean): void {
    this.desabilitado = estaDesabilitado;
  }

  aoMudarSelecao(valor: number | number[] | null): void {
    this.valorSelecionadoInterno = valor;
  }
} 